import { add, isNumber, subtract, toNumber } from 'lodash-es';
import React, { FC } from 'react';
import Button from '../Button/Button';
import { IconMinus, IconPlus } from '../Icons/Icons';
import styles from './InputNumber.module.scss';

interface InputNumberProps {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
}

const InputNumber: FC<InputNumberProps> = props => {
  const { value = 0, onChange, min, max, disabled } = props;
  const isMin = isNumber(min);
  const isMax = isNumber(max);

  const handleChange = (newValue: number) => {
    if (isMin && newValue < min) {
      newValue = min;
    } else if (isMax && newValue > max) {
      newValue = max;
    }

    onChange?.(newValue);
  };

  return (
    <span className="d-inline-flex align-items-center text-center" style={{ gap: 6 }}>
      <Button
        tertiary
        disabled={disabled || (isMin ? value <= min : undefined)}
        rounded
        onClick={() => handleChange(subtract(value, 1))}
      >
        <IconMinus size={24} />
      </Button>
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        onChange={e => handleChange(toNumber(e.currentTarget.value))}
        className={styles.input}
        disabled={disabled}
      />
      <Button
        primary
        disabled={disabled || (isMax ? value >= max : undefined)}
        rounded
        onClick={() => handleChange(add(value, 1))}
      >
        <IconPlus size={24} />
      </Button>
    </span>
  );
};

export default InputNumber;
